/**
 * @auth 赖传峰
 * @date 2023/9/26
 * @desc 针对 Web Deep Link 拦截 http://wiki.xunlei.cn/pages/viewpage.action?pageId=120401201
 */
import { RouteQueryKeyActionValue } from '@/types/enum'
import _ from 'lodash'
import qs from 'qs'

const showDialogActions = _.without(
  Object.values(RouteQueryKeyActionValue),
  RouteQueryKeyActionValue.OPEN_FILE,
  RouteQueryKeyActionValue.SHOW_TASK,
  RouteQueryKeyActionValue.HIGHLIGHT_FILES,
  RouteQueryKeyActionValue.SEARCH,
)

const urlInstance = (deepLink: string) => {
  const webOrigin = process.dev ? 'https://dev.mypikpak.com' : 'https://mypikpak.com'
  try {
    return new URL(deepLink, webOrigin)
  } catch (err) {
    console.log('new URL error:', deepLink, err)
    return undefined
  }
}

const webDeepLinkSearch = (deepLink: string): boolean => {
  const url = urlInstance(deepLink)
  if (!url) return false

  const { action } = qs.parse(url.search.slice(1))
  const actions = (Array.isArray(action) ? action : [action]) as (string | undefined)[]
  return (
    url.pathname.startsWith('/drive') && showDialogActions.some(el => actions.some(_el => _el && _el.startsWith(el)))
  )
}

export default async (ev: MouseEvent) => {
  const targetOrigin = new URL(window.location.href).searchParams.get('origin')
  if (window.parent !== window && targetOrigin) {
    const deepLinkAnchor = ev
      .composedPath()
      .find(el => el instanceof HTMLAnchorElement && webDeepLinkSearch(el.href)) as HTMLAnchorElement | undefined
    if (deepLinkAnchor) {
      ev.preventDefault()
      const url = urlInstance(deepLinkAnchor.href)
      if (!url) return

      const parsedQuery = qs.parse(url.search.slice(1))
      if (parsedQuery.target === '_blank') return window.open(url)

      window.parent?.postMessage({ action: url.searchParams.get('action') }, targetOrigin)
    }
    const feedbackDeepLinkAnchor = ev
      .composedPath()
      .find(el => el instanceof HTMLAnchorElement && el.getAttribute('href')?.includes('/drive/feedback'))
    if (feedbackDeepLinkAnchor) {
      ev.preventDefault()
      window.parent?.postMessage({ action: 'open_feedback' }, targetOrigin)
    }
  }
}
